"use client";
import { CompositeContextProvider, CompositeScopedContextProvider } from "../composite/composite-context.js";
import { createStoreContext } from "@ariakit/react-utils";
//#region src/radio/radio-context.tsx
const ctx = createStoreContext([CompositeContextProvider], [CompositeScopedContextProvider]);
/**
* Returns the radio store from the nearest radio container.
* @example
* function Radio() {
*   const store = useRadioContext();
*
*   if (!store) {
*     throw new Error("Radio must be wrapped in RadioProvider");
*   }
*
*   // Use the store...
* }
*/
const useRadioContext = ctx.useContext;
const useRadioScopedContext = ctx.useScopedContext;
const useRadioProviderContext = ctx.useProviderContext;
const RadioContextProvider = ctx.ContextProvider;
const RadioScopedContextProvider = ctx.ScopedContextProvider;
//#endregion
export { RadioContextProvider, RadioScopedContextProvider, useRadioContext, useRadioProviderContext, useRadioScopedContext };

//# sourceMappingURL=radio-context.js.map